import SteuerruecklagenTemplate from './templates/SteuerruecklagenTemplate';
import { STEUERRUECKLAGEN_CONFIG } from './config/steuerruecklagen';

export default function SteuerruecklagenSchweiz() {
  return <SteuerruecklagenTemplate cfg={STEUERRUECKLAGEN_CONFIG.CH} />;
}
